import { MapIcon } from 'lucide-react';
import * as React from 'react';
import { Translate } from 'react-localize-redux';
import CompaniesAndMapView from '../../containers_v2/client-companies/CompaniesAndMapView';
import { PrimaryColor } from '../../styles/global/css/Utils';
import { Route } from '../Routes';

const CompaniesRoutes = (): Route[] => [
	{
		component: CompaniesAndMapView,
		path: '/map',
		name: <Translate id="general.map" />,
		role: ['all'],
		key: 'map',
		sectionKey: 'map',
		logoImg: <MapIcon size='16' />,
		hoverImg: <MapIcon color={PrimaryColor} size='16' />,
		activeImg: <MapIcon color={PrimaryColor} size='16' />,
		title: <Translate id="general.map"/>,
		subTitle: 'company map',
		permission: ['ViewMap'],
		restricted: false,
		exact: true,
		menu: true,
		precedence: 1
	}
];

export default CompaniesRoutes;
